(function () {
  'use strict';

  /* @ngdoc object
   * @name main.llista
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.llista', [
      'ui.router'
    ]);
}());
